import React, { FC } from 'react'
import {
  Editor as Draw,
  EditingMode,
  DrawPointMode,
  DrawLineStringMode,
  DrawPolygonMode,
  DrawRectangleMode,
  DrawCircleFromCenterMode,
} from 'react-map-gl-draw'
import { getFeatureStyle, getEditHandleStyle } from './styles'
import { EditorModes } from 'models/editor'
import { useMapEditorContext } from 'context/map-editor-context'

const MODE_TO_HANDLER: { [key in EditorModes]: any } = {
  [EditorModes.SELECT]: undefined,
  [EditorModes.READ_ONLY]: undefined,
  [EditorModes.EDITING]: EditingMode,
  [EditorModes.DRAW_POINT]: DrawPointMode,
  [EditorModes.DRAW_PATH]: DrawLineStringMode,
  [EditorModes.DRAW_RECTANGLE]: DrawRectangleMode,
  [EditorModes.DRAW_POLYGON]: DrawPolygonMode,
  [EditorModes.DRAW_CIRCLE]: DrawCircleFromCenterMode,
}

export const Editor: FC = () => {
  const [{ editor }, mapEditorDispatch] = useMapEditorContext()
  const { mode, feature } = { ...editor }
  const editorMode = MODE_TO_HANDLER[mode] ? new MODE_TO_HANDLER[mode]() : undefined
  const editing = !editorMode

  return (
    <div style={{ cursor: editing ? 'inherit' : 'crosshair' }}>
      <Draw
        mode={editorMode}
        features={feature ? [feature] : []}
        selectedFeatureIndex={feature ? 0 : null}
        featureStyle={getFeatureStyle}
        editHandleStyle={getEditHandleStyle}
        editHandleShape="circle"
        onUpdate={(features: any) => {
          features.data.length > 0 &&
            mapEditorDispatch.updateFeature(features.data[features.data.length - 1])
        }}
      />
    </div>
  )
}

Editor.displayName = 'Editor'
